import DtoUserStatistic from './DtoUserStatistic'

export default class DtoUserUsageStatistic extends DtoUserStatistic {
    constructor(obj) {
        super(obj)
    }
}